// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"38bfd920","239":"870373ae","488":"a8cea8cd","732":"dcac09f3"}[chunkId] + ".chunk.js";
};